(function () {
  function initHeroSlider(root) {
    const track = root.querySelector(".hero__slider-track");
    if (!track) return;

    // slides = orice element direct din capture-ul "media":
    // img.hero__image, video.hero__video, svg placeholder etc.
    const slides = Array.from(track.children);
    if (slides.length <= 1) return;

    const prev = root.querySelector(".hero__slider-arrow--prev");
    const next = root.querySelector(".hero__slider-arrow--next");
    const dotsWrap = root.querySelector(".hero__slider-dots");

    let index = 0;
    let timer = null;

    const autoplay = root.dataset.heroSliderAutoplay === "true";
    const interval = (parseInt(root.dataset.heroSliderInterval || "5", 10) || 5) * 1000;

    // dots
    let dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      dots = slides.map((_, i) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "hero__slider-dot" + (i === 0 ? " is-active" : "");
        b.setAttribute("aria-label", `Go to slide ${i + 1}`);
        b.addEventListener("click", () => goTo(i, true));
        dotsWrap.appendChild(b);
        return b;
      });
    }

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
    }

    function goTo(i, userAction) {
      index = (i + slides.length) % slides.length;
      update();
      if (userAction) restart();
    }

    function restart() {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(() => goTo(index + 1, false), interval);
    }

    prev && prev.addEventListener("click", () => goTo(index - 1, true));
    next && next.addEventListener("click", () => goTo(index + 1, true));

    // swipe
    let startX = 0;
    let down = false;
    root.addEventListener("pointerdown", (e) => { down = true; startX = e.clientX; });
    root.addEventListener("pointerup", (e) => {
      if (!down) return;
      down = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) < 40) return;
      dx < 0 ? goTo(index + 1, true) : goTo(index - 1, true);
    });
    root.addEventListener("pointercancel", () => (down = false));

    // pause on hover
    root.addEventListener("mouseenter", () => timer && clearInterval(timer));
    root.addEventListener("mouseleave", () => restart());

    restart();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-hero-slider]").forEach(initHeroSlider);
  });
})();
